export enum DocumentFileSubtype {
  ACQUISITION = 'DOCUMENTO_AQUISICAO',
  OWNERSHIP = 'DOCUMENTO_POSSE',
  MARITAL_STATUS = 'DOCUMENTO_ESTADO_CIVIL',
  IDENTITY = 'DOCUMENTO_IDENTIDADE'
}
